import { IncomingHttpHeaders } from 'http'

export function getGuestKey(headers: IncomingHttpHeaders = {}): string {
  const guestKey = headers['x-guest-key'] as string

  return guestKey
}
